import React from "react";
import classnames from 'classnames'
import Link from '../Link'
import "./styles.scss";

const component = ({ id, unitNumber, isSaved, imageUrl, layoutName, bathroomCount, sqft, moveInDate, price, floorplanUrl,showAsterisk }) => {
  const formattedMoveInDate = formatMoveInDate(moveInDate);
  const isAvailableNow = formattedMoveInDate === 'Available Now';
  const isAvailableNowAndHasSqft = isAvailableNow && sqft !== undefined;

  return (
    <div role={"group"} tabIndex="0" className={classnames('listing-preview', {'listing-preview--available-now-with-sqft': isAvailableNowAndHasSqft})}>
      <div className="listing-preview__image" style= { ({backgroundImage: "url(" + imageUrl + ")"}) }>
        {isSaved && <div className="listing-preview__savedMsg">Saved Listing</div>}
      </div>
      <div className="listing-preview__info">
        <div className="listing-preview__title">{layoutName} &#8226; {bathroomCount} Bath</div>
        <div className="listing-preview__row listing-preview__middle-box">
          <div className="listing-preview__cell">
            { unitNumber }
          </div>
          {sqft && (
            <div className="listing-preview__cell" aria-label={`${unitNumber} square footage`}>{ sqft }sqft</div>
          )}
          {floorplanUrl && (
            <div className="listing-preview__cell">
              <a href={floorplanUrl} aria-label={`${unitNumber} Floorplan`} target="_blank">Floorplan</a>
            </div>
          )}
        </div>
        <div className="listing-preview__row listing-preview__bottom-box">
          <div className="listing-preview__cell listing-preview__price" aria-label={`${unitNumber} price`}>${ price }/mo{showAsterisk}</div>
          <Link className="listing-preview__cell button button--primary" aria-label={`${unitNumber} details`} to={'/listing?id='+ id}>
            Details
          </Link>
        </div>
      </div>
    </div>
  )
}

component.displayName = 'ListingPreview';
export default component;

function formatMoveInDate(moveInDate) {
  if(!moveInDate) {
    typeof Raven !== "undefined" &&
      Raven.captureMessage('Unexpectedly received missing move in date.'); // eslint-disable-line no-undef

    return '';
  }

  if(moveInDate < Date.now()) {
    return 'Available Now';
  }

  const year = String(moveInDate.getFullYear()).substr(-2, 2);
  const month = moveInDate.getMonth() + 1;
  const date = moveInDate.getDate();
  return `${month}/${date}/${year}`;
}



// WEBPACK FOOTER //
// ./client/components/ListingPreview/index.js